<template>
  <div class="chat mt-16 pt-1 mt-md-10 fill-height">
    <div
      v-if="current.inner_context"
      class="text-center px-4 py-2"
    >
      {{ current.inner_context }}
    </div>

    <div
      v-for="(message, i) in messages"
      :key="i"
      class="d-flex mx-4 my-4"
    >
      <BaseAvatar class="custom-elevation-2 custom-outline" img="angry" />
      <v-card
        rounded="lg"
        class="quiz-text ml-4 px-6 py-4 custom-elevation custom-border"
      >
        {{ message }}
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuizHome',
  props: {
    current: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    messages() {
      const text = this.$localized(this.current, 'text');
      return text.split('<new>') || [];
    },
  },
};
</script>
